@if (showTabs) {
<nav class="feature-tabs-container">
    <div class="tabs-wrapper">
        @for (tab of tabs; track tab.label) {
        <a [routerLink]="tab.route" [queryParams]="tab.queryParams" class="tab-item" [class.active]="isActive(tab)">
            <span class="tab-label">{{ tab.label }}</span>
            <div class="active-indicator"></div>
        </a>
        }
    </div>
</nav>
}